import { useEffect, useState } from 'react'

/** True after mount — safe to read localStorage without hydration/rerender flicker. */
export function useClientHydrated() {
  const [hydrated, setHydrated] = useState(false)

  useEffect(() => {
    setHydrated(true)
  }, [])

  return hydrated
}
